import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const overStayList = createAsyncThunk('overStay/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'visitor_overstay',
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'created_at': data?.date
                    ? (moment(data.date, 'YYYY-MM-DD', true).isValid()
                        ? data.date
                        : moment(data.date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
                    : undefined,
                'fDate': data?.fDate || undefined,
                'tDate': data?.tDate || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const overstayReminder = createAsyncThunk('overStay/reminder', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'overstay_reminder',
            data,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const overStay = createSlice({
    name: 'overStay',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(overStayList.pending, (state) => {
            state.loading = true
        });
        builder.addCase(overStayList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(overStayList.rejected, (state) => {
            state.loading = false
        });
    }
})

export default overStay.reducer;